import React, { memo, useState } from 'react';
import classNames from 'classnames';
import map from 'lodash/map';
import styles from './HorizontalMenu.module.scss';
import HorizontalTabLink from './HorizontalTabLink';

function HorizontalMenu({
  tabs,
  light,
  onTabChange,
  containerClassName,
  tabClassName,
  initialTabIndex = 0,
}) {
  const [pageIndex, setPageIndex] = useState(initialTabIndex);
  const containerClasses = classNames(styles.container, containerClassName);

  function handleTabClick(index) {
    setPageIndex(index);

    if (onTabChange) {
      onTabChange(index);
    }
  }

  function renderTab(tab, index) {
    const resolvedIndex = tab.index || index;

    return (
      <HorizontalTabLink
        key={resolvedIndex}
        className={tabClassName}
        light={light}
        onClick={() => handleTabClick(resolvedIndex)}
        active={pageIndex === resolvedIndex}
      >
        {tab.label}
      </HorizontalTabLink>
    );
  }

  return (
    <div className={containerClasses}>
      {map(tabs, (tab, index) => renderTab(tab, index))}
    </div>
  );
}

export default memo(HorizontalMenu);
